import React, { useEffect, useState } from "react";
import { Youtube, Instagram, Facebook, Twitter, Linkedin, Twitch, Send, MessageCircle, Globe } from "lucide-react";

export const SOCIAL_NETWORKS = [
  ["youtube", "YouTube channel URL", "youtube"],
  ["instagram", "Instagram URL", "instagram"],
  ["tiktok", "TikTok URL", "tiktok"],
  ["facebook", "Facebook page URL", "facebook"],
  ["x", "X (Twitter) URL", "x"],
  ["reddit", "Reddit profile or community URL (e.g. reddit.com/r/mrqkuk)", "reddit"],
  ["linkedin", "LinkedIn page URL", "linkedin"],
  ["pinterest", "Pinterest URL", "pinterest"],
  ["threads", "Threads URL", "threads"],
  ["snapchat", "Snapchat URL", "snapchat"],
  ["whatsapp", "WhatsApp channel / chat link", "whatsapp"],
  ["telegram", "Telegram channel URL", "telegram"],
  ["discord", "Discord invite URL", "discord"],
  ["bluesky", "Bluesky profile URL", "bluesky"],
  ["twitch", "Twitch channel URL", "twitch"],
];

const LUCIDE = { youtube: Youtube, instagram: Instagram, facebook: Facebook, x: Twitter, linkedin: Linkedin, twitch: Twitch, telegram: Send, whatsapp: MessageCircle };
const CDN_SLUG = { tiktok: "tiktok", reddit: "reddit", pinterest: "pinterest", threads: "threads", snapchat: "snapchat", discord: "discord", bluesky: "bluesky" };

export const SocialIcon = ({ network, className = "w-4 h-4", color = "ffffff" }) => {
  const [broken, setBroken] = useState(false);
  const Lucide = LUCIDE[network];
  if (Lucide) return <Lucide className={className} aria-hidden="true" />;
  if (CDN_SLUG[network] && !broken) {
    return <img src={`https://cdn.simpleicons.org/${CDN_SLUG[network]}/${color}`} alt="" aria-hidden="true" className={className} loading="lazy" onError={() => setBroken(true)} />;
  }
  return <Globe className={className} aria-hidden="true" />;
};

export const useSocials = () => {
  const [socials, setSocials] = useState({});
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/socials`).then((r) => r.json()).then(setSocials).catch(() => {});
  }, []);
  return socials;
};
